import * as _ from 'lodash';
import { N_YEARS } from '../constants/years';
import { timeseriesArray } from './utils';

export const isYearSpecified = (revenueStreams, year) =>
  revenueStreams.some(
    ({ percent, unitCost, unitsPerTree }) =>
      percent[year] != null ||
      unitCost[year] != null ||
      unitsPerTree?.[year] != null,
  );

const unitsPerTreeValid = (stream, year) =>
  stream.unitsPerTree == null || stream.unitsPerTree[year] != null;

const allStreamFieldsValidForYear = (stream, year) =>
  unitsPerTreeValid(stream, year) &&
  stream.percent[year] != null &&
  stream.unitCost[year] != null;

const everyStreamSpecifiedForYear = (revenueStreams, year) =>
  revenueStreams.every(
    (s) => s.isDeleted || allStreamFieldsValidForYear(s, year),
  );

// If any year is specified, all years must be specified
// And at least one year must be specified
export const revenueStreamsSpecified = (revenueStreams) => {
  const timeseries = timeseriesArray({ length: N_YEARS });
  return (
    timeseries.every(
      (year) =>
        !isYearSpecified(revenueStreams, year) ||
        everyStreamSpecifiedForYear(revenueStreams, year),
    ) &&
    (timeseries.some((year) => isYearSpecified(revenueStreams, year)) ||
      revenueStreams.every((s) => s.isDeleted))
  );
};

export const percentsValidForYear = (revenueStreams, year) =>
  _.sum(revenueStreams.map((s) => _.get(s, `percent[${year}]`) || 0)) === 100;

export const allPercentsValid = (revenueStreams) => {
  return timeseriesArray({
    length: N_YEARS,
  }).every(
    (year) =>
      !isYearSpecified(revenueStreams, year) ||
      percentsValidForYear(revenueStreams, year),
  );
};
